/**
 * Раскладка именованных фото-полей карточки (UploadsRow, стили — _tool-mode.scss).
 *
 * До четырёх полей — правила владельца 28.09: 1–2 подписи сбоку, 3 в ряд, 4 парами 2×2, между плитками цепочка
 * стрелок (у четырёх между парами стрелки нет). От пяти (владелец 18.10: «адаптивная вёрстка, чтобы слоты фото не
 * ломали слот результата») — сетка плиток одного размера, которая переносится по ширине зоны сама: сколько влезло в
 * ряд — столько и стоит, остальное уходит вниз, а не под колонку результата (проверка 18.10: при 6–7 полях ряд уезжал
 * под результат, шестое поле резалось, седьмого не было видно). Стрелок в сетке нет: порядок задают подписи, а висячая
 * стрелка в конце ряда показывала в никуда.
 */
export const NAMED_SLOTS_GRID_FROM = 5
/** От стольких полей плитки ещё на шаг меньше (владелец 18.10: «слоты можно немного уменьшать в размерах в таком случае»). */
export const NAMED_SLOTS_DENSE_FROM = 9

export function namedSlotsClassName(count: number): string {
	const grid = count >= NAMED_SLOTS_GRID_FROM ? ' gm__namedslots--many' : ''
	const dense = count >= NAMED_SLOTS_DENSE_FROM ? ' gm__namedslots--dense' : ''
	return `gm__faceswap gm__namedslots gm__namedslots--${count}${grid}${dense}`
}

/** Стрелка перед полем i: 'arrow' — обычная, 'pair-break' — между парами у четырёх полей (стили её прячут), null — нет. */
export function namedSlotArrow(count: number, i: number): 'arrow' | 'pair-break' | null {
	if (i === 0 || count >= NAMED_SLOTS_GRID_FROM) return null
	return count === 4 && i === 2 ? 'pair-break' : 'arrow'
}
